<template>
	<div>
		<breadcrumbs />
		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								Register a Terminal Device Licence
							</h6>
							<div class="element-box-tp">
								<div class="element-box">
									<h5 class="form-header">Register</h5>
									<div class="form-desc">Please enter a valid reseller id</div>
									<form class="form-inline" v-on:submit="create">
										<label class="sr-only"> First Name</label>
										<input type="number" v-model="resellerId" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="RESELLER ID">
										
										<button v-show="resellerId" class="btn btn-primary" type="submit"> Create</button>
									</form>
									<div v-show="registered" class="mt-2 alert alert-success">REGISTERED TERMINAL ID: {{ registered }}</div>
									<div v-show="error" class="mt-2 alert alert-warning">{{ error }}</div>
									</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'create',
        data () {
            return {
               t: this.$root.t,
			   resellerId: null,
			   error: null,
			   registered: null
            }
        },
		methods: {
			create(evt){
				evt.preventDefault();
				this.$http.post(api+"api/v2/terminal/create", {reseller_id: this.resellerId}) .then(response => {
					this.error = null
					this.registered =  response.body.terminalID
				}, response => {
                    this.error = response.body.msg
                })
				
			}
		}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/terminal/create.vue